import React , { useState, useEffect } from 'react';
import styles from './Footer.module.css';
// import logimg from '../../assets/images/sparq_logo.png';
// eslint-disable-next-line
import logimg from '../../assets/images/logo_dashboard.png';

const Footer = () => {

  const[LastRefreshData,setLastRefreshData] = useState();
  
  useEffect(()=>{
    
    const LastRefreshDate = () => {
      // eslint-disable-next-line global-require
      const axios = require('axios');
      const config = {
        method: 'get',
        url: 'https://pinsights.esakha-pre-prod.tatamotors.com/api/refreshdateapi',
        headers: { 
          'Authorization': 'Basic U3dhcm46UmF0bjEyMzQ='
        }
      };

      axios(config)
      .then((response) => {
        setLastRefreshData(response.data[0].refreshdate)
      })
      .catch((error) => {
        console.log(error);
      });
    };

    setTimeout(() => {
      LastRefreshDate();
    }, 2000);
      
  },[]);

  return (
  <div className={styles.footer}>
    <span style={{marginLeft:"10px", marginTop:"4px", fontSize:"13px"}}>Last Refreshed: {LastRefreshData}</span>
    <span className={styles.footerText}>
      Copyright 2023 <span className={styles.companyName}>Tata Motors</span>.
      All rights reserved
    </span>
    {/* <span className={styles.rightContainer} style={{textAlign:"center", marginRight:"5px"}}>Powered by SparQPlug</span>
    <img className={styles.rightContainer} src={logimg} alt="Tata Motors" /> */}
  </div>
);
}

export default Footer;
